<template>
  <CCard>
    <CCardHeader>
      {{ router.name }}({{ router.dns_name }})
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="6">
          <CCard>
            <CCardHeader>
              Router Info
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.name"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-comment-bubble" />
                      &nbsp;Name
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.dns_name"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-devices" />
                      &nbsp;DNS Name
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.router_ip"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-router" />
                      &nbsp;Router IP
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value="router.cmdb ? router.cmdb.uuid : ''"
                    disabled
                  >
                    <template #prepend-content>
                      <CIcon name="cil-tag" />
                      &nbsp;Device UUID
                    </template>
                  </CInput>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <CButton
                color="primary"
                square
                @click="editRouterSetting"
              >
                Submit
              </CButton>
            </CCardFooter>
          </CCard>
          <CCard>
            <CCardHeader>
              Connection Info
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.host"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-laptop" />
                      &nbsp;Api Connect Host
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.port"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-rss" />
                      &nbsp;Port
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.username"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-user" />
                      &nbsp;Username
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.password"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked" />
                      &nbsp;Password
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.location"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-location-pin" />
                      &nbsp;Location
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="router.isp"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-sim" />
                      &nbsp;ISP
                    </template>
                  </CInput>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <CButtonGroup>
                <CButton
                  color="primary"
                  square
                  @click="editRouterSetting()"
                >
                  Submit
                </CButton>
                <CButton
                  v-if="!router.is_controlling"
                  color="danger"
                  square
                  @click="initRouter()"
                >
                  Init Router
                </CButton>
                <CButton
                  v-if="router.is_controlling"
                  color="warning"
                  square
                  @click="initRouter()"
                >
                  Re-Init
                </CButton>
              </CButtonGroup>
            </CCardFooter>
          </CCard>
          <CCard v-if="router.dhcp_address && router.dhcp_address.length > 0">
            <CCardHeader>
              Dhcp Address List
            </CCardHeader>
            <CCardBody>
              <CDataTable
                small
                fixed
                sorter
                :items-per-page="5"
                :fields="dhcpAddressListFields"
                :items="router.dhcp_address"
                :noItemsView="{ noItems: 'No Item~' }"
                pagination
                :sorterValue="{column: 'interface_name'}"
              >
                <template #cmdbDeviceName="{item}">
                  <td class="py-2">
                    {{ item.cmdb_device.name }}
                  </td>
                </template>
                <template #action="{item}">
                  <td class="py-2">
                    <CButtonGroup>
                      <CButton
                        color="info"
                        square
                        @click="$router.push('/cmdb/device/view/'+item.cmdb_device.id);"
                      >
                        Go CMDB Page
                      </CButton>
                    </CButtonGroup>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
          </CCard>
          <CCard v-if="$cookies.get('is_admin') === '1'">
            <CCardHeader>
              Routing Tables
            </CCardHeader>
            <CCardBody>
              <CDataTable
                small
                fixed
                sorter
                :items-per-page="10"
                :fields="routingTableFields"
                :items="routingTables"
                :noItemsView="{ noItems: 'No routing table synced' }"
                pagination
              >
                <template #is_fib="{item}">
                  <td class="py-2">
                    <CBadge :color="item.is_fib ? 'success' : 'secondary'">
                      {{ item.is_fib ? 'FIB' : '-' }}
                    </CBadge>
                  </td>
                </template>
              </CDataTable>
              <CCardText>
                <small class="text-muted">由 agent 定期同步，每 30 分钟刷新</small>
              </CCardText>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm="6">
          <CCard>
            <CCardHeader>
              Dhcp Pool List
            </CCardHeader>
            <CCardBody>
              <CDataTable
                small
                fixed
                sorter
                :items-per-page="5"
                :fields="dhcpPoolListFields"
                :items="router.dhcp_server"
                :noItemsView="{ noItems: 'No Item~' }"
                pagination
                :sorterValue="{column: 'interface_name'}"
              >
                <template #action="{item}">
                  <td class="py-2">
                    <CButtonGroup>
                      <CButton
                        color="danger"
                        square
                        @click="deleteRouterDhcpServer(item.id)"
                      >
                        Delete
                      </CButton>
                    </CButtonGroup>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
            <CCardFooter>
              <CCardText>Add dhcp server</CCardText>
              <CRow>
                <CCol sm="12">
                  <CInput
                    :value.sync="server_name"
                    placeholder="Dhcp server name.eg:server-xxx"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-terminal" />
                      &nbsp;Dhcp Server Name
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CInput
                    :value.sync="addresses"
                    placeholder="x.x.x.x/xx"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-list" />
                      &nbsp;Addresses block
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="12">
                  <CButton
                    color="success"
                    square
                    @click="addRouterDhcpServer"
                  >
                    Add
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
          <CCard>
            <CCardHeader>
              Tunnel Endpoints
            </CCardHeader>
            <CCardBody>
              <CDataTable
                small
                fixed
                sorter
                :items-per-page="5"
                :fields="tunnelEndpointFields"
                :items="tunnelEndpoints"
                :noItemsView="{ noItems: 'No Item~' }"
                pagination
              >
                <template #action="{item}">
                  <td class="py-2">
                    <CButtonGroup>
                      <CButton
                        color="danger"
                        square
                        size="sm"
                        @click="deleteTunnelEndpoint(item)"
                      >
                        Delete
                      </CButton>
                    </CButtonGroup>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
            <CCardFooter>
              <CCardText>Add tunnel endpoint (创建后不可修改)</CCardText>
              <CRow>
                <CCol sm="5">
                  <CInput
                    :value.sync="tunnelEndpointAddress"
                    placeholder="domain or IP"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-globe-alt" />
                      &nbsp;Address
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="3">
                  <CSelect
                    :options="tunnelEndpointFamilyOptions"
                    :value.sync="tunnelEndpointFamily"
                  />
                </CCol>
                <CCol sm="2">
                  <CInput
                    :value.sync="tunnelEndpointRemark"
                    placeholder="端点用途"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-comment-bubble" />
                      &nbsp;Remark
                    </template>
                  </CInput>
                </CCol>
                <CCol sm="2">
                  <CButton
                    color="success"
                    square
                    @click="addTunnelEndpoint"
                  >
                    Add
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
          <CCard>
            <CCardHeader>
              Config Backup
            </CCardHeader>
            <CCardBody>
              <CRow class="mb-2">
                <CCol sm="12">
                  <CInputCheckbox
                    :checked.sync="backupEnabled"
                    label="Auto Backup"
                    custom
                  />
                </CCol>
              </CRow>
              <CRow class="mb-2 align-items-center">
                <CCol sm="4">
                  <label class="form-label">Interval (minutes)</label>
                </CCol>
                <CCol sm="4">
                  <CInput
                    :value.sync="backupInterval"
                    type="number"
                    placeholder="1440"
                  />
                </CCol>
                <CCol sm="4">
                  <CButton
                    color="success"
                    square
                    size="sm"
                    @click="saveBackupConfig"
                  >
                    Save
                  </CButton>
                </CCol>
              </CRow>
              <hr/>
              <div class="mb-2">
                <small class="text-muted" v-if="lastBackupAt">
                  Last backup: {{ lastBackupAt | dateFormat }}
                </small>
              </div>
              <CDataTable
                small
                fixed
                sorter
                :items-per-page="5"
                :fields="backupFields"
                :items="backupList"
                :noItemsView="{ noItems: 'No backup yet' }"
                pagination
                class="mt-3"
              >
                <template #created_at="{item}">
                  <td class="py-2">
                    {{ item.created_at | dateFormat }}
                  </td>
                </template>
                <template #type="{item}">
                  <td class="py-2">
                    <CBadge :color="item.backup_type === 2 ? 'info' : 'secondary'">
                      {{ item.backup_type === 2 ? 'Manual' : 'Auto' }}
                    </CBadge>
                  </td>
                </template>
                <template #size="{item}">
                  <td class="py-2">
                    {{ item.file_size }} B
                  </td>
                </template>
                <template #status="{item}">
                  <td class="py-2">
                    <CBadge :color="item.status === 1 ? 'success' : 'danger'">
                      {{ item.status === 1 ? 'Success' : 'Failed' }}
                    </CBadge>
                    <CBadge v-if="item.locked" color="warning" style="margin-left: 4px;">🔒 Locked</CBadge>
                  </td>
                </template>
                <template #action="{item}">
                  <td class="py-2">
                    <CButtonGroup>
                      <CButton
                        v-if="item.status === 1"
                        color="info"
                        variant="outline"
                        square
                        size="sm"
                        @click="showBackupDetail(item)"
                      >
                        View
                      </CButton>
                      <CButton
                        v-if="item.status === 1"
                        color="success"
                        square
                        size="sm"
                        @click="downloadBackup(item)"
                      >
                        Download
                      </CButton>
                      <CButton
                        color="warning"
                        square
                        size="sm"
                        @click="toggleBackupLock(item)"
                      >
                        {{ item.locked ? 'Unlock' : 'Lock' }}
                      </CButton>
                      <CButton
                        color="danger"
                        square
                        size="sm"
                        :disabled="!!item.locked"
                        @click="deleteBackup(item)"
                      >
                        Delete
                      </CButton>
                    </CButtonGroup>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CCardBody>
    <CToaster :autohide="3000">
      <template v-for="toast in fixedToasts">
        <CToast
          :key="'toast' + toast"
          :show="true"
          :color="alertLevel"
          header="Alert"
        >
          {{ returnMsg }}
        </CToast>
      </template>
    </CToaster>
    <CModal
      title="Request Message"
      color="primary"
      :show.sync="requestMsgModal"
    >
      {{ requestMsg }}
      <template #footer>
        <CButton @click="requestMsgModal=false" color="primary">Close</CButton>
      </template>
    </CModal>
    <CModal
      title="Backup Detail"
      color="primary"
      :show.sync="backupDetailModal"
      size="xl"
    >
      <pre style="max-height:600px;overflow:auto;background:#f8f9fa;padding:10px;border-radius:4px;font-size:12px;">{{ backupDetailContent }}</pre>
      <template #footer>
        <CButton @click="backupDetailModal=false" color="primary">Close</CButton>
      </template>
    </CModal>
  </CCard>
</template>

<script>
export default {
  name: "View",
  data() {
    const dhcpPoolListFields = [
      { key: "server_name", label: "Pool Name" },
      { key: "addresses", label: "Addresses Block" },
      {
        key: "action",
        label: "Action",
        sorter: false,
        filter: false,
        _style: "width: 30%"
      }
    ];
    const dhcpAddressListFields = [
      { key: "ip", label: "IP Address" },
      { key: "cmdbDeviceName", label: "Device Name" },
      {
        key: "action",
        label: "Action",
        sorter: false,
        filter: false,
        _style: "width: 30%"
      }
    ];
    const backupFields = [
      { key: "created_at", label: "Time" },
      { key: "type", label: "Type" },
      { key: "size", label: "Size" },
      { key: "status", label: "Status" },
      {
        key: "action",
        label: "Action",
        sorter: false,
        filter: false,
        _style: "width: 25%"
      }
    ];
    const routingTableFields = [
      { key: "name", label: "Table Name" },
      { key: "is_fib", label: "FIB", _style: "width: 80px" }
    ];
    const tunnelEndpointFields = [
      { key: "address", label: "Address" },
      { key: "address_family", label: "Family" },
      { key: "remark", label: "Remark" },
      {
        key: "action",
        label: "Action",
        sorter: false,
        filter: false,
        _style: "width: 15%"
      }
    ];
    return {
      fixedToasts: 0,
      returnMsg: "",
      alertLevel: "success",
      requestMsgModal: false,
      requestMsg: null,
      id: this.$route.params.id,
      router: {},
      dhcpPoolListFields,
      server_name: null,
      addresses: null,
      dhcpAddressListFields,
      backupFields,
      backupList: [],
      routingTableFields,
      routingTables: [],
      tunnelEndpointFields,
      tunnelEndpoints: [],
      tunnelEndpointAddress: null,
      tunnelEndpointFamily: "ipv4",
      tunnelEndpointFamilyOptions: [
        { value: "ipv4", label: "IPv4" },
        { value: "ipv6", label: "IPv6" }
      ],
      tunnelEndpointRemark: null,
      backupEnabled: false,
      backupInterval: 1440,
      lastBackupAt: null,
      backupDetailModal: false,
      backupDetailContent: "",
    };
  },
  mounted: function() {
    this.onLoadPage();
  },
  methods: {
    onLoadPage: function() {
      this.$axios.get("user/router/" + this.id + "/view", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.router = response.data.router;
          }
        });
      this.loadBackups();
      this.loadTunnelEndpoints();
      if (this.$cookies.get('is_admin') === '1') {
        this.loadRoutingTables();
      }
    },
    initRouter: function() {
      this.$axios.post("user/router/" + this.id + "/init", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.onLoadPage();
          } else {
            this.requestMsg = "Init Error";
            this.requestMsgModal = true;
          }
        });
    },
    editRouterSetting: function() {
      this.$axios.post("user/router/" + this.id + "/edit", {
        name: this.router.name,
        router_ip: this.router.router_ip,
        dns_name: this.router.dns_name,
        host: this.router.host,
        port: this.router.port,
        username: this.router.username,
        password: this.router.password,
        location: this.router.location,
        isp: this.router.isp
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.onLoadPage();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    addRouterDhcpServer: function() {
      this.$axios.post("user/router/dhcp-server/add", {
        router_id: this.id,
        server_name: this.server_name,
        addresses: this.addresses
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.onLoadPage();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    deleteRouterDhcpServer: function(dhcp_server_id) {
      this.$axios.delete("user/router/dhcp-server/"+ dhcp_server_id +"/delete", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.onLoadPage();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    loadBackups: function() {
      this.$axios.get("user/router/" + this.id + "/backup", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.backupList = response.data.backups;
            this.backupEnabled = response.data.backup_enabled === 1;
            this.backupInterval = response.data.backup_interval;
            this.lastBackupAt = response.data.last_backup_at;
          }
        });
    },
    loadRoutingTables: function() {
      this.$axios.get("user/routing/rule/routers/" + this.id + "/tables", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.routingTables = response.data.data || [];
          }
        });
    },
    saveBackupConfig: function() {
      this.$axios.post("user/router/" + this.id + "/backup/config", {
        backup_enabled: this.backupEnabled ? 1 : 0,
        backup_interval: this.backupInterval
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    showBackupDetail: function(backup) {
      this.backupDetailContent = "Loading...";
      this.backupDetailModal = true;
      this.$axios.get("user/router/backup/" + backup.id + "/view", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.backupDetailContent = response.data.backup.config_content || "(empty)";
          }
        });
    },
    downloadBackup: function(backup) {
      window.open(this.$axios.defaults.baseURL + "user/router/backup/" + backup.id + "/download", "_blank");
    },
    deleteBackup: function(backup) {
      if (!confirm("Delete this backup?")) return;
      this.$axios.delete("user/router/backup/" + backup.id + "/delete", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.loadBackups();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    toggleBackupLock: function(backup) {
      this.$axios.post("user/router/backup/" + backup.id + "/lock", {
        locked: backup.locked ? 0 : 1
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.loadBackups();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    loadTunnelEndpoints: function() {
      this.$axios.get("user/tunnel/endpoint/list", {
        params: {
          owner_type: "router",
          router_id: this.id
        }
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.tunnelEndpoints = response.data.endpoints;
          }
        });
    },
    addTunnelEndpoint: function() {
      if (!this.tunnelEndpointAddress) {
        this.requestMsg = "Address can not be null";
        this.requestMsgModal = true;
        return;
      }
      this.$axios.post("user/tunnel/endpoint/add", {
        owner_type: "router",
        router_id: this.id,
        address: this.tunnelEndpointAddress,
        address_family: this.tunnelEndpointFamily,
        remark: this.tunnelEndpointRemark
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.tunnelEndpointAddress = null;
            this.tunnelEndpointRemark = null;
            this.loadTunnelEndpoints();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    deleteTunnelEndpoint: function(item) {
      if (!confirm("Delete endpoint " + item.address + "?")) return;
      this.$axios.delete("user/tunnel/endpoint/" + item.id + "/delete", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.loadTunnelEndpoints();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
  }
};
</script>